import { useAuth } from "./AuthProvider";
import { Navigate } from "react-router-dom";
import { Box } from "@mui/material";
import DataLoader from "./components/DataLoader";

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const { user, token, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
        <DataLoader />
      </Box>
    );
  }

  if (!user || !token) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
